import { Outlet } from "react-router-dom";
import classNames from "classnames";
import PageState from "../components/PageState";
import SideBar from "../components/sidebar/SideBar";
import Header from "../components/header/Header";
import Notification from "../components/notification/Notification";
import { useHasScrollbar } from "../js/scrolling";
import { useGlobalState } from "../GlobalContext";

function DefaultLayout() {
  const globalState = useGlobalState();
  const hasScrollbar = useHasScrollbar();

  return (
    <>
      <PageState />
      <main
        className={classNames(
          globalState.showNavigation ? "sidebar-expanded" : ""
        )}
      >
        <SideBar />
        <div id="content-container">
          <Header />
          <div
            id="content"
            className={classNames(
              hasScrollbar ? "has-scrollbar" : "has-no-scrollbar"
            )}
          >
            <Outlet />
          </div>
        </div>
        <Notification />
      </main>
    </>
  );
}

export default DefaultLayout;
